


import { Vue, Component } from 'vue-property-decorator';
import Tabs from '@/_ui/tabs/tabs.vue';
import {TTab} from '@/_ui/tabs/types/tabs.type';

@Component({
  components: {
    Tabs,
  },
})
export default class CabinetExponentsTabs extends Vue {

  public tabList: TTab[] = [
    {
      title: this.$t('cabinet.exponents.tabs.companies'),
      isActive: this.$route.name === 'promo-page-cabinet-exponents',
      rightTopBadge: null,
      index: 0,
    },
    {
      title: this.$t('cabinet.exponents.tabs.floorPlan'),
      isActive: this.$route.name === 'promo-page-cabinet-event-map',
      rightTopBadge: null,
      index: 1,
    }
  ];

  public onActiveTabUpdate(tab: any, activeTabIndex: number): void {
    const routes: string[] = ['promo-page-cabinet-exponents', 'promo-page-cabinet-event-map'];
    this.$router.push({
      name: routes[activeTabIndex],
    });
  }

}
